﻿import document from 'document';
import { scroller } from '../../utilities/scroller';

export const anchorList = () => {

    const scrollToTarget = elem => {        
        const targetAnchor = elem.getAttribute('href');
        const target = document.querySelector(targetAnchor);

        scroller.scrollToElement(target);
    };

    const init = component => {
        component.addEventListener('click', event => {            
           if(event.target.classList.contains('js-anchor-link')){
                event.preventDefault();
                scrollToTarget(event.target);
            }
        });
    };

    return {
        init: init,
        selector: '[data-component="anchor-list"]'
    };
};